import {
  SendContentType,
  WhatsAppFileMessageType,
  WhatsAppImageMessageType,
  WhatsAppMsgType,
} from "../../types";
import {
  WhatsAppFileSendData,
  WhatsAppImageSendData,
  WhatsAppSendDataType,
} from "./send-message";

const baseMessage = {
  chat_id: "",
  another_id: "",
  conversation_id: "",
  msg_server_id: "",
  msg_unique_identifier: "",
  request_key: "",
  sender_id: "",
  timestamp: 0,
  from_user_id: "",
  robot_task_id: "",
};

export const convertSendDataToWhatsAppMessage = (
  data: WhatsAppSendDataType
) => {
  const { type } = data;
  switch (type) {
    case SendContentType.IMAGE: {
      const send_data = data.send_data as WhatsAppImageSendData;
      return {
        ...baseMessage,
        msg_type: WhatsAppMsgType.QW_IMAGE,
        file_url: send_data?.path,
        file_name: send_data?.file_name,
      } as WhatsAppImageMessageType;
    }
    case SendContentType.FILE: {
      const send_data = data.send_data as WhatsAppFileSendData;
      return {
        ...baseMessage,
        msg_type: WhatsAppMsgType.QW_FILE,
        file_url: send_data?.path,
        file_name: send_data?.file_name,
      } as WhatsAppFileMessageType;
    }
  }
};
